/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringweeks1Inputs */

const en_recurringweeks1 = /** @type {(inputs: Recurringweeks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weeks`)
};

const de_recurringweeks1 = /** @type {(inputs: Recurringweeks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochen`)
};

/**
* | output |
* | --- |
* | "weeks" |
*
* @param {Recurringweeks1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringweeks1 = /** @type {((inputs?: Recurringweeks1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringweeks1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringweeks1(inputs)
	return de_recurringweeks1(inputs)
});
export { recurringweeks1 as "recurringWeeks" }